<template>
  <Layout>
    <customer-create-modal
        id="customer-create-modal"
        :key="`customer-create-modal`"
        :deny-customer-select="true"
        :initial-value="{ registered: false }"
        :modal-title="`BUAT PELANGGAN BARU`"
        @created="refreshTable"
    ></customer-create-modal>
    <customer-edit-modal
        id="customer-edit-modal"
        :key="`customer-edit-modal`"
        ref="customer_edit_modal"
        :modal-title="`EDIT PELANGGAN`"
        @updated="refreshTable"
    ></customer-edit-modal>
    <customer-create-modal
        id="customer-create-v2"
        :key="`customer-create-v2`"
        @created="refreshTable"
    ></customer-create-modal>
    <odoo-obligor-limit
        id="odoo-obligor-limit"
        :key="`odoo-obligor-limit`"
        ref="odoo_obligor_limit"
        @updated="refreshTable"
    ></odoo-obligor-limit>
    <customer-summary
        :key="`customer-summary-${customerSummaryLoading}`"
        :loading="customerSummaryLoading"
        :summary="customerSummary"
    />
    <b-card>
      <div class="row mb-2">
        <div class="col-sm-12 col-md-6">
          <div class="font-size-600 text-neutral-300">
            {{ cardTitle }}
          </div>
        </div>
        <div class="col-sm-12 col-md-6 d-flex justify-content-end">
          <b-button
              v-if="$auth.hasPermissionTo('customers.sync')"
              :disabled="syncLoading"
              class="me-2"
              style="border: 1px solid #D0D5DD"
              variant="white"
              @click="onClickSyncUpdatedToday"
          >
            <i v-if="syncLoading" class="fa fa-sync fa-spin me-1"/>
            {{ lodash.startCase($t('customers.sync_data')) }}
          </b-button>
          <b-button variant="primary" @click="showCreateModal" v-if="!denyCreate">{{ $t('Create New') }}</b-button>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-12 col-md-6">
          <customer-type-button-group
              v-model="activeCustomerType"
          />
        </div>
        <div class="d-flex col-12 col-md-6 justify-content-md-end">
          <div>
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center w-100">
                <b-form-select
                    v-model="perPage"
                    :options="[10, 50, 100, 250, 1000]"
                    class="form-select-sm"
                    size="sm"
                    @change="$emit('update:perPage', $event)"
                ></b-form-select
                >&nbsp;
              </label>
            </div>
          </div>
          <!-- Search -->
          <div class="w-100">
            <div id="tickets-table_filter" class="dataTables_filter text-md-end">
              <div class="prefix-icon">
                <svg fill="none" height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M11.8374 10.7933L15 13.9552L13.9552 15L10.7933 11.8374C9.61682 12.7805 8.15349 13.2935 6.64566 13.2913C2.97726 13.2913 0 10.3141 0 6.64566C0 2.97726 2.97726 0 6.64566 0C10.3141 0 13.2913 2.97726 13.2913 6.64566C13.2935 8.15349 12.7805 9.61682 11.8374 10.7933ZM10.3562 10.2454C11.2933 9.28169 11.8166 7.98988 11.8145 6.64566C11.8145 3.7895 9.50108 1.47681 6.64566 1.47681C3.7895 1.47681 1.47681 3.7895 1.47681 6.64566C1.47681 9.50108 3.7895 11.8145 6.64566 11.8145C7.98988 11.8166 9.28169 11.2933 10.2454 10.3562L10.3562 10.2454Z"
                      fill="#7E889D"
                  />
                </svg>
              </div>

              <label class="d-inline-flex align-items-center w-100">
                <b-form-input
                    :debounce="500"
                    :placeholder="$t('Pencarian') + '...'"
                    :value="searchInput"
                    class="form-control form-control-sm ms-2"
                    type="search"
                    @input="onSearchInput"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-table
              v-if="isCustomerTableMode"
              ref="table"
              :busy="busy"
              :current-page="page"
              :fields="tableColumns"
              :filter="filterParams"
              :items="itemProvider"
              :per-page="perPage"
              :responsive="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              class="table-model mb-2"
              head-variant="light"
              hover
              show-empty
              sticky-header
              style="margin: 0; min-height: 475px;"
              thead-class="align-middle"
              @update:busy="$emit('update:busy', $event)"
              @row-clicked="onRowClicked"
          >
            <template #table-colgroup="{ fields }">
              <col v-for="field in fields" :key="field.key" v-bind="field"/>
            </template>
            <template #cell(index)="data">
              <b>{{ data.index + from }}</b>
            </template>
            <template #cell(action)="data">
              <div class="d-inline-flex justify-content-center w-100" @click.stop @mousedown.stop>
                <b-dropdown
                    v-if="!data.item['_denyShow'] || !data.item['_denyEdit'] || !data.item['_denyDelete']"
                    class="card-drop"
                    menu-class="dropdown-menu-end"
                    toggle-class="p-0"
                    variant="white"
                >
                  <template v-slot:button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <slot name="action" v-bind="{ data }">
                    <b-dropdown-item v-if="!data.item['_denyShow']" @click="handleShow(data.item)">
                      {{ $t("Detail") }}
                    </b-dropdown-item>
                    <b-dropdown-item v-if="!data.item['_denyEdit']" @click="showEditModal(data.item)">
                      {{ $t("Edit") }}
                    </b-dropdown-item>
                    <b-dropdown-item v-if="!data.item['_denyDelete']" @click="$emit('delete-click', data.item)">
                      <span class="text-danger">{{ $t("Delete") }}</span>
                    </b-dropdown-item>
                  </slot>
                </b-dropdown>
              </div>
            </template>
            <template #cell()="data">
              <template v-if="data.field.component">
                <component
                    :is="data.field.component"
                    v-bind="{ item: data.item }"
                    v-on="data.field['componentListeners'] || {}"
                ></component>
              </template>
              <template v-else>{{ data.value }}</template>
            </template>
            <template #empty="scope">
              <Loader :loading="busy" no-axios>
                <div
                    class="card shadow-none rounded-0"
                    style="margin: -0.75rem; background-color: #F5F6F7;height: 475px"
                >
                  <div
                      style="position: absolute;
                  left: 50%;
                  top: 40%;
                  transform: translate(-50%, -50%);"
                  >
                    <div class="d-flex justify-content-center">
                      <img
                          alt="not found"
                          src="@/assets/images/report_gmailerrorred_24px.png"
                          style="height: 48px;width: 48px;"
                      />
                    </div>
                    <p class="table-status-text">{{ lodash.upperFirst($t("search_not_found")) }}</p>
                  </div>
                </div>
              </Loader>
            </template>
            <template #emptyfiltered="scope">
              <Loader :loading="busy" no-axios>
                <div
                    class="card shadow-none rounded-0"
                    style="margin: -0.75rem; background-color: #F5F6F7;height: 475px"
                >
                  <div
                      style="position: absolute;
                  left: 50%;
                  top: 40%;
                  transform: translate(-50%, -50%);"
                  >
                    <div class="d-flex justify-content-center">
                      <img
                          alt="not found"
                          src="@/assets/images/report_gmailerrorred_24px.png"
                          style="height: 48px;width: 48px;"
                      />
                    </div>
                    <p class="table-status-text">{{ lodash.upperFirst($t("search_not_found")) }}</p>
                  </div>
                </div>
              </Loader>
            </template>
            <template #table-busy>
              <TableBusyLoader :loading="true" no-axios>
                <div
                    class="card shadow-none rounded-0"
                    style="margin: -0.75rem; background-color: #F5F6F7; height: 475px;"
                >
                  <p
                      class="position-absolute table-status-text"
                      style="
                  height: 40px;
                  position: absolute;
                  left: 50%;
                  top: 30%;
                  transform: translate(-50%, -50%);
                  "
                  >
                    {{ lodash.upperFirst($t("fetch_data")) }}
                  </p>
                </div>
              </TableBusyLoader>
            </template>
            <template #row-details="{ item }">
              <b-table
                  :key="`child-detail-table-${item.id}-${mixedLimitFetchId}`"
                  ref="childTable"
                  :busy="busy"
                  :fields="columns['childMixedLimitGroup']"
                  :items="childLimits(item)"
                  :responsive="true"
                  borderless
                  class="table-model m-0 child-detail-table"
                  head-variant="light"
                  hover
                  show-empty
                  sort-by="name"
                  sticky-header
                  thead-class="align-middle"
                  thead-tr-class="d-none"
                  @filtered="$emit('filtered', $event)"
                  @update:busy="$emit('update:busy', $event)"
                  @row-clicked="onChildRowClicked"
              >
                <template #cell(action)="data">
                  <div class="d-inline-flex justify-content-center w-100" @click.stop @mousedown.stop>
                    <b-dropdown
                        v-if="!data.item['_denyShow'] || !data.item['_denyEdit'] || !data.item['_denyDelete']"
                        class="card-drop"
                        menu-class="dropdown-menu-end"
                        toggle-class="p-0"
                        variant="white"
                    >
                      <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal"></i>
                      </template>
                      <slot name="action" v-bind="{ data }">
                        <b-dropdown-item v-if="!data.item['_denyShow']" @click="handleShow(data.item)">
                          {{ $t("Detail") }}
                        </b-dropdown-item>
                        <b-dropdown-item v-if="!data.item['_denyEdit']" @click="showEditModal(data.item)">
                          {{ $t("Edit") }}
                        </b-dropdown-item>
                        <b-dropdown-item v-if="!data.item['_denyDelete']" @click="$emit('delete-click', data.item)">
                          <span class="text-danger">{{ $t("Delete") }}</span>
                        </b-dropdown-item>
                      </slot>
                    </b-dropdown>
                  </div>
                </template>
                <template #cell(name)="row">
                  {{ row.item.name }}
                </template>
                <template #cell(limit_amount)="row">
                  {{ formatCurrency(row.item.limit_amount) }}
                </template>
                <template #cell(used_amount)="row">
                  {{ formatCurrency(row.item.used_amount) }}
                </template>
                <template #cell(used_amount_ratio)="row">
                  <b-badge :variant="usedAmountRatioVariant(row.item.used_amount_ratio)">
                    {{ formatPercentage(row.item.used_amount_ratio) }}
                  </b-badge>
                </template>
                <template #cell(available_amount)="row">
                  {{ formatCurrency(row.item.available_amount) }}
                </template>
                <template #cell(max_days_past_due_in_90_days)="row">
                  <b-badge :variant="dpdStatusVariant(row.item.max_days_past_due_in_90_days)" class="d-block">
                    {{ row.item.max_days_past_due_in_90_days || '-' }}
                  </b-badge>
                </template>
              </b-table>
            </template>
          </b-table>
          <template v-else>
            <Loader :loading="busy" no-axios>
              <div class="table-model mb-2" style="margin: 0; min-height: 475px;">
                <b-table-simple
                    class="table b-table mixed-limit-table"
                    hover
                    responsive
                    striped
                >
                  <b-thead class="align-middle" head-variant="light">
                    <b-tr>
                      <b-th class="w-45px" style="width: 45px">No</b-th>
                      <b-th
                          v-for="field in mixedLimitBodyColumns"
                          :key="`mixed-limit-head-${field.key}`"
                          :class="[
                              field.thClass,
                              field.class,
                              isMixedLimitSortable(field) ? 'cursor-pointer' : '',
                            ]"
                          :style="field.thStyle || field.style"
                          v-bind="mixedLimitSortAttrs(field)"
                          @click="isMixedLimitSortable(field) && toggleMixedLimitSort(field.key)"
                      >
                        {{ field.label || '' }}
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody v-if="displayedMixedLimitRows.length">
                    <b-tr
                        v-for="(row, rowIndex) in displayedMixedLimitRows"
                        :key="row._displayKey || `mixed-limit-row-${rowIndex}`"
                        :class="[
                            row._displayRowKind === 'child' ? 'mixed-limit-child-row' : 'mixed-limit-parent-row',
                            row.type === 'group' ? 'mixed-limit-group-row' : '',
                          ]"
                        style="cursor: pointer;"
                        @click="onMixedLimitRowClicked(row)"
                    >
                      <b-td class="w-45px" style="width: 45px">
                        <b>{{ row._displayIndex }}</b>
                      </b-td>
                      <b-td
                          v-for="field in mixedLimitBodyColumns"
                          :key="`${row._displayKey || rowIndex}-${field.key}`"
                          :class="[
                              field.tdClass,
                              field.class,
                              row._displayRowKind === 'child' ? 'mixed-limit-child-cell' : '',
                            ]"
                          :style="field.style"
                      >
                        <div v-if="field.key === 'action'" class="d-inline-flex justify-content-center w-100"
                             @click.stop @mousedown.stop>
                          <slot name="action" v-bind="{ data: { item: row, index: rowIndex } }">
                            <b-dropdown
                                v-if="!row['_denyShow'] || !row['_denyEdit'] || !row['_denyDelete']"
                                class="card-drop"
                                menu-class="dropdown-menu-end"
                                toggle-class="p-0"
                                variant="white"
                            >
                              <template v-slot:button-content>
                                <i class="mdi mdi-dots-horizontal"></i>
                              </template>
                              <b-dropdown-item v-if="!row['_denyShow']" @click="handleShow(row)">
                                {{ $t("Detail") }}
                              </b-dropdown-item>
                              <b-dropdown-item v-if="!row['_denyEdit']" @click="showEditModal(row)">
                                {{ $t("Edit") }}
                              </b-dropdown-item>
                              <b-dropdown-item v-if="!row['_denyDelete']" @click="$emit('delete-click', row)">
                                <span class="text-danger">{{ $t("Delete") }}</span>
                              </b-dropdown-item>
                            </b-dropdown>
                          </slot>
                        </div>
                        <component
                            :is="field.component"
                            v-else-if="field.component"
                            v-bind="{ item: row }"
                            v-on="field['componentListeners'] || {}"
                        ></component>
                        <template v-else>{{ renderTableFieldValue(row, field) }}</template>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                  <b-tbody v-else>
                    <b-tr>
                      <b-td :colspan="mixedLimitBodyColumns.length + 1" class="p-0">
                        <Loader :loading="busy" no-axios>
                          <div
                              class="card shadow-none rounded-0"
                              style="margin: -0.75rem; background-color: #F5F6F7;height: 475px"
                          >
                            <div
                                style="position: absolute;
                  left: 50%;
                  top: 40%;
                  transform: translate(-50%, -50%);"
                            >
                              <div class="d-flex justify-content-center">
                                <img
                                    alt="not found"
                                    src="@/assets/images/report_gmailerrorred_24px.png"
                                    style="height: 48px;width: 48px;"
                                />
                              </div>
                              <p class="table-status-text">{{ lodash.upperFirst($t("search_not_found")) }}</p>
                            </div>
                          </div>
                        </Loader>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </Loader>
          </template>
          <div class="row">
            <div class="col-sm-12 col-md-6 d-flex align-items-center"
                 style="color: #98A2B3; font: 400 12px/14px Lato, sans-serif">
              {{ lodash.upperFirst($t('customers.latest_updated_at')) }}:
              {{ $moment.utc(lastSuccessSyncAt).local().format('YYYY-MM-DD HH:mm') }}
            </div>
            <div class="col-sm-12 col-md-6">
              <div v-if="total > perPage" class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <b-pagination
                        :key="`pagination-button-${total}-${perPage}`"
                        v-model="page"
                        :disabled="busy"
                        :per-page="perPage"
                        :total-rows="total"
                        class="pagination pagination-rounded d-flex m-0"
                        @change="onPageChanged"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>

  </Layout>
</template>

<script>
import icons from "@/assets/icons";
import JalaAppIcon from "@/assets/icons/JalaApp.svg";
import JalaHarvestIcon from "@/assets/icons/JalaHarvest.svg";
import JalaProIcon from "@/assets/icons/JalaPro.svg";
import ModelFilter from '@/components/model-filter-v3'
import ModelIndex from "../models/index-v3"
import CustomerCreateModal from '@/components/modals/customer-create'
import CustomerEditModal from '@/components/modals/customer-edit'
import TableBusyLoader from "@/components/widgets/table-busy-loader.vue";
import CustomerTypeButtonGroup from "@/router/views/customers/index/customer-type-button-group.vue";
import OdooObligorLimit from "@/components/modals/odoo-obligor-limit.vue";
import {daysPastDueVariant, usedAmountRatioVariant} from "@/helpers/ui/badgeVariants";
import CustomerSummary from "@/router/views/customers/index/customer-summary.vue";
import Swal from "sweetalert2";

/* eslint-disable vue/no-unused-components */
export default {
  extends: ModelIndex,
  page: {
    title: "Customers",
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t('customers.plural'))
      }
    },
    resourceRoute: {default: 'customers'},
    modelVariable: {default: 'customer'},
    denyCreate: {
      type: Boolean, default() {
        return !this.$auth.hasPermissionTo("customers.create")
      }
    }
  },
  components: {
    CustomerSummary,
    OdooObligorLimit,
    CustomerTypeButtonGroup,
    TableBusyLoader,
    ModelFilter,
    CustomerCreateModal,
    CustomerEditModal,
    JalaAppIcon,
    JalaHarvestIcon,
    JalaProIcon,
  },
  data() {
    return {
      mixedLimitGroupTableItems: null,
      mixedLimitFetchId: 0,
      tableRefreshQueued: false,
      tableReady: false,
      title: this.lodash.upperFirst(this.$t('customers.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('customers.plural')),
          href: "/customers",
          active: true,
        },
      ],
      searchInput: this.search,
      activeCustomerType: 'processing',
      filterColumns: {
        name: {type: String, label: this.lodash.upperFirst(this.$t('customers.name'))},
        code: {type: String, label: this.lodash.upperFirst(this.$t('customers.code'))},
        type: {
          type: String,
          label: this.lodash.upperFirst('tipe'),
          input_component: 'customer-role-select',
        }
      },
      customerSummary: {
        total: 0,
        typeFarmer: 0,
        typePartner: 0,
        typeProcessing: 0,
      },
      customerSummaryLoading: false,
      syncLoading: false,
      lastSuccessSyncAt: this.$moment(),
    }
  },
  watch: {
    "$route.query": {
      handler(value, oldValue) {
        if (this.queryKey) {
          // only triger routeQueryChanged if value !== oldValue
          if (this.lodash.isEqual(value[this.queryKey], oldValue[this.queryKey])) return;
        }
        this.routeQueryChanged(value);
      },
      deep: true
    },
    activeCustomerType(val, oldVal) {
      if (val === oldVal) return
      this.page = 1
      this.$set(this, 'filter', {
        ...this.filter,
        type: val,
      })
      this.applyDefaultCustomerSort(val)
      this.scheduleRefreshTable()
    },
    search(value) {
      this.searchInput = value;
      if (this.tableReady) {
        this.scheduleRefreshTable()
      }
    },
    page() {
      if (this.tableReady) {
        this.scheduleRefreshTable()
      }
    },
    perPage() {
      if (this.tableReady) {
        this.scheduleRefreshTable()
      }
    },
    sortBy() {
      if (this.tableReady) {
        this.scheduleRefreshTable()
      }
    },
    sortDesc() {
      if (this.tableReady) {
        this.scheduleRefreshTable()
      }
    },
  },
  computed: {
    tableColumns() {
      if (['farmer', 'partner'].includes(this.activeCustomerType)) {
        return this.columns['customer']
      }

      return this.columns['mixedLimitGroup']
    },
    isCustomerTableMode() {
      return ['farmer', 'partner'].includes(this.activeCustomerType)
    },
    mixedLimitTableColumns() {
      return this.columns['mixedLimitGroup'] || []
    },
    mixedLimitBodyColumns() {
      return this.mixedLimitTableColumns.filter(column => column.key !== 'index')
    },
    sortedMixedLimitRows() {
      const rows = Array.isArray(this.models) ? [...this.models] : []
      const sortKey = this.sortBy || 'code'
      const sortDirection = this.sortDesc ? 'desc' : 'asc'

      return this.lodash.orderBy(
          rows,
          [row => this.mixedLimitSortValue(row, sortKey)],
          [sortDirection]
      )
    },
    displayedMixedLimitRows() {
      const rows = []

      this.sortedMixedLimitRows.forEach((row, index) => {
        const parentIndex = this.from + index
        rows.push(this.decorateMixedLimitRow(row, {
          displayIndex: parentIndex,
          displayKey: `group-${row.id ?? index}`,
          rowKind: 'parent',
        }))

        if (row.type === 'group' && row._showDetails) {
          this.sortMixedLimitRows(this.childLimits(row), this.sortBy).forEach((childRow, childIndex) => {
            rows.push(this.decorateMixedLimitRow(childRow, {
              displayIndex: null,
              displayKey: `group-${row.id ?? index}-child-${childRow.id ?? childIndex}`,
              rowKind: 'child',
              parentDisplayIndex: parentIndex,
            }))
          })
        }
      })

      return rows
    },
    columns() {
      return {
        ['customer']: [
          {key: 'index', label: 'No', sortable: false, style: {width: '1%'}},
          {
            key: 'code',
            label: this.lodash.upperFirst(this.$t('customers.code')),
            thStyle: {minWidth: '100px'},
            style: {width: '5%'},
            sortable: true,
            formatter: (value) => {
              if (value === null) {
                return '-';
              } else {
                return value.toUpperCase();
              }
            }
          },
          {
            key: 'name',
            label: this.lodash.upperFirst(`${this.$t('customers.name')} ${this.$t(`customers.types.${this.activeCustomerType}`)}`),
            thStyle: {minWidth: '125px'},
            style: {width: '15%'},
            sortable: true,
            component: {
              props: ['item'],
              data() {
                return {
                  icons,
                  JalaAppIcon,
                  JalaHarvestIcon,
                  JalaProIcon
                }
              },
              computed: {
                isJalaAppUser() {
                  return this.item.farms?.find(farm => farm.use_jala_farm)
                },
                isCycleProUser() {
                  return this.item.farms?.find(farm => farm.pro_ponds?.length)
                },
                tooltip() {
                  if (this.isJalaAppUser && this.isCycleProUser) {
                    return "Terdaftar dalam Siklus Pro";
                  } else if (this.isJalaAppUser) {
                    return "Pengguna JALA Apps";
                  }
                  return "Mitra JALA Harvest";
                }
              },
              template: `
                <div v-b-tooltip.hover :title="tooltip" class="d-flex align-items-center gap-2">
                  <div class="d-flex align -items-center">
                    <img v-if="isJalaAppUser && isCycleProUser" :src="JalaProIcon" style="width: 16px; height: 16px"/>
                    <img v-else-if="isJalaAppUser" :src="JalaAppIcon" style="width: 16px; height: 16px"/>
                    <img v-else :src="JalaHarvestIcon" style="width: 16px; height: 16px"/>
                  </div>
                  <div>
                    {{ lodash.get(item, "name") }}
                  </div>
                </div>
              `
            }
          },
          {
            key: 'types',
            label: this.lodash.upperFirst(this.$t('customers.type')),
            thStyle: {minWidth: '175px'},
            style: {width: '15%'},
            formatter: values => values?.map(value => this.lodash.startCase(this.$t(`customers.types.${value}`))).sort().join(', '),
          },
          {
            key: 'address.street',
            label: this.lodash.upperFirst('wilayah'),
            thStyle: {minWidth: '400px'},
            style: {width: '30%'},
            component: {
              props: ['item'],
              computed: {
                types() {
                  if (!this.item.address.street) {
                    return '-'
                  }
                  return `(${this.item.types.map(value => this.lodash.startCase(this.$t(`customers.types.${value}`))).sort().join(', ')})`
                },
                address_keys() {
                  return Object.keys(this.customer_addresses());
                },
              },
              methods: {
                customer_addresses() {
                  const addresses = {};
                  this.item.farms?.map((farm) => {
                    if (farm.region_full_name) {
                      addresses[farm.region_full_name] = ['farmer'];
                    }
                  })
                  this.item.addresses?.map((address) => {
                    if (!this.item.types.find(value => value === address?.type)) return
                    if (!address.region_full_name) return
                    if (!addresses[address.region_full_name]) {
                      addresses[address.region_full_name] = []
                    }

                    addresses[address.region_full_name].push(address.type)

                  })
                  return addresses;
                },
                address_value(key) {
                  // return this.$t(`customers.types.${this.customer_addresses()[key].join(',')}`)
                  return this.customer_addresses()[key].map((address) => this.$t(`customers.types.${address}`)).join(', ')
                },
              },
              template: `
                <div>
                  <div v-for="key in Object.keys(customer_addresses())" style="font-size: 12px">
                    {{ key }} ({{ address_value(key) }})
                  </div>
                </div>
              `
            }
          },
          {
            key: 'creator.name',
            label: this.lodash.startCase(this.$t('models.created_by')),
            thStyle: {minWidth: '100px'},
            sortable: false,
            formatter: (value) => value || '-'
          },
          {key: 'action', label: this.$t('Action'), class: 'text-center', style: {width: '1%'}}
        ],
        ['mixedLimitGroup']: [
          {key: 'index', label: 'No', sortable: false, style: {width: '45px'}, thClass: 'w-45px', tdClass: 'w-45px'},
          {
            key: ' ',
            style: {width: '35px'},
            component: {
              props: ['item'],
              computed: {
                isGroup() {
                  return this.item.type === 'group'
                }
              },
              template: `
                <template v-if="isGroup">
                  <i v-if="!item._showDetails" class="fa fa-angle-right"/><i v-else class="fa fa-angle-down"/>
                </template>
                <template v-else></template>`,
            },
          },
          {
            key: 'code',
            label: this.lodash.upperFirst(this.$t('customers.code')),
            style: {width: '150px'},
            sortable: true,
            component: {
              props: ['item'],
              computed: {
                code() {
                  return this.item?.alias_code ?? this.item?.code;
                }
              },
              template: `
                <template>{{ code }}</template>`,
            },
          },
          {
            key: 'name',
            label: `${this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.name'))} ${this.lodash.upperFirst(this.$t('customers.types.processing'))}`,
            style: {width: '200px'},
            sortable: true,
            component: {
              props: ['item'],
              computed: {
                name() {
                  return this.item?.alias_name ?? this.item?.name;
                }
              },
              template: `
                <template>{{ name }}</template>`,
            },
          },
          {
            key: 'limit_amount',
            label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.limit')),
            style: {width: '200px'},
            sortable: true,
            formatter: (value) => this.$numeral(value).format('$0,0.[00]'),
          },
          {
            key: 'used_amount',
            label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.usage')),
            style: {width: '200px'},
            thClass: 'w-200px',
            tdClass: 'w-200px',
            formatter: (value) => this.$numeral(value).format('$0,0.[00]'),
          },
          {
            key: 'used_amount_ratio',
            label: '%',
            style: {width: '70px'},
            thClass: 'text-end',
            tdClass: 'text-end',
            component: {
              props: ['item'],
              methods: {
                usedAmountRatioVariant,
                percentageFormatter(value) {
                  return this.$numeral(value).format('0,0.[00]%')
                },
              },
              template: `
                <b-badge :variant="usedAmountRatioVariant(item.used_amount_ratio)">
                  {{ percentageFormatter(item.used_amount_ratio) }}
                </b-badge>`
            },
          },
          {
            key: 'available_amount',
            thClass: 'w-150px',
            tdClass: 'w-150px',
            label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.remaining')),
            formatter: (value) => this.$numeral(value).format('$0,0.[00]'),
          },
          {
            key: 'max_days_past_due_in_90_days',
            label: this.lodash.startCase((this.$t('odoo_limit_obligor_groups.dpd_status'))),
            style: {width: '70px'},
            thClass: 'text-center',
            tdClass: 'text-center',
            component: {
              props: ['item'],
              computed: {
                maxDaysPastDueIn90Days() {
                  if (!['individual', 'group', 'child'].includes(this.item.type)) {
                    return 0
                  }
                  if (this.item.type === 'individual') {
                    return this.item.odoo_res_partner?.max_days_past_due_in_90_days
                  } else if (this.item.type === 'child') {
                    return this.item.max_days_past_due_in_90_days
                  }
                  let dpdIn90Days = this.item.odoo_obligor_limits
                      .map(limit => limit.odoo_res_partner?.max_days_past_due_in_90_days)
                      .filter(v => Number.isInteger(v))
                  if (dpdIn90Days.length === 0) {
                    return null
                  }
                  return Math.max(...dpdIn90Days)
                },
              },
              methods: {
                daysPastDueVariant,
                formattedDaysPastDue(days_past_due) {
                  return days_past_due ?? '-'
                },
              },
              template: `
                <b-badge class="d-block" :variant="daysPastDueVariant(maxDaysPastDueIn90Days)">
                  {{ formattedDaysPastDue(maxDaysPastDueIn90Days) }}
                </b-badge>`
            },
          },
          {
            key: 'action',
            label: this.$t('Action'),
            class: 'text-center',
            style: {width: '1%'},
            thStyle: {width: '1%'},
            tdClass: 'text-center w-1'
          }
        ],
        ['childMixedLimitGroup']: [
          {key: 'index', label: 'No', thStyle: {width: '80'}, tdClass: 'w-80px p-12px'},
          {
            key: 'code',
            label: this.lodash.upperFirst(this.$t('customers.code')),
            thStyle: {width: '150px'},
            tdClass: 'w-150px p-12px'
          },
          {
            key: 'name',
            label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.name')),
            thStyle: {width: '200px'},
            tdClass: 'w-200px p-12px'
          },
          {
            key: 'limit_amount',
            label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.limit')),
            thStyle: {width: '200px'},
            tdClass: 'w-200px p-12px',
            sortable: true,
            formatter: (value) => this.$numeral(value).format('$0,0.[00]'),
          },
          {
            key: 'used_amount',
            label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.usage')),
            thStyle: {width: '200px'},
            tdClass: 'w-200px p-12px',
            formatter: (value) => this.$numeral(value).format('$0,0.[00]'),
          },
          {
            key: 'used_amount_ratio',
            label: '%',
            thClass: 'text-end',
            thStyle: {width: '70px'},
            tdClass: 'text-end w-70px p-12px',
          },
          {
            key: 'available_amount',
            label: this.lodash.upperFirst(this.$t('odoo_limit_obligor_groups.remaining')),
            thClass: 'w-150px',
            tdClass: 'w-150px',
            formatter: (value) => this.$numeral(value).format('$0,0.[00]'),
          },
          {
            key: 'max_days_past_due_in_90_days',
            label: 'DPD',
            style: {width: '70px'},
            thClass: 'text-center w-70px',
            tdClass: 'text-center w-70px',
          },
          {
            key: 'action',
            label: this.$t('Action'),
            class: 'text-center',
            style: {width: '1%'},
            thStyle: {width: '1%'},
            tdClass: 'text-center w-1'
          }
        ]
      };
    },
  },
  mounted() {
    this.initFilter();
    this.activeCustomerType = this.$route.query.type || 'processing';
    if (!this.$route.query.sort) {
      this.applyDefaultCustomerSort(this.activeCustomerType)
    }
    this.filterWatch = true;
    this.tableReady = true;
    this.refreshTable()
  },
  methods: {
    dpdStatusVariant: daysPastDueVariant,
    usedAmountRatioVariant,
    applyDefaultCustomerSort(customerType = this.activeCustomerType) {
      if (customerType === 'processing') {
        this.sortBy = 'limit_amount'
        this.sortDesc = true
        return
      }

      this.sortBy = 'code'
      this.sortDesc = false
    },
    scheduleRefreshTable() {
      if (this.tableRefreshQueued || !this.tableReady) {
        return
      }
      this.tableRefreshQueued = true
      this.$nextTick(() => {
        this.tableRefreshQueued = false
        this.refreshTable()
      })
    },
    sortMixedLimitRows(rows = [], sortKey = this.sortBy) {
      const sortDirection = this.sortDesc ? 'desc' : 'asc'
      return this.lodash.orderBy(
          Array.isArray(rows) ? [...rows] : [],
          [row => this.mixedLimitSortValue(row, sortKey)],
          [sortDirection]
      )
    },
    mixedLimitSortValue(row, key) {
      if (!row) {
        return ''
      }

      switch (key) {
        case 'code':
          return (row.alias_code ?? row.code ?? '').toString().toLowerCase()
        case 'name':
          return (row.alias_name ?? row.name ?? '').toString().toLowerCase()
        case 'limit_amount':
        case 'used_amount':
        case 'available_amount':
        case 'used_amount_ratio':
        case 'max_days_past_due_in_90_days':
          return Number(row[key] ?? 0)
        default:
          return row[key] ?? ''
      }
    },
    decorateMixedLimitRow(row, meta = {}) {
      return {
        ...row,
        _sourceRow: row,
        _displayIndex: meta.displayIndex,
        _displayKey: meta.displayKey,
        _displayRowKind: meta.rowKind,
        _displayParentIndex: meta.parentDisplayIndex ?? null,
      }
    },
    getTableFieldValue(item, field) {
      if (!field || !field.key || field.key.trim() === '') {
        return null
      }

      return field.key.split('.').reduce((value, key) => {
        if (value === null || typeof value === 'undefined') {
          return undefined
        }
        return value[key]
      }, item)
    },
    renderTableFieldValue(item, field) {
      const value = this.getTableFieldValue(item, field)
      if (typeof field.formatter === 'function') {
        return field.formatter(value, field.key, item)
      }
      return value ?? '-'
    },
    isMixedLimitSortable(field) {
      return Boolean(field && field.sortable)
    },
    isMixedLimitSortableKey(fieldKey) {
      return this.mixedLimitBodyColumns.some(field => field.key === fieldKey && field.sortable)
    },
    toggleMixedLimitSort(fieldKey) {
      if (!fieldKey) {
        return
      }

      this.page = 1
      if (this.sortBy === fieldKey) {
        this.sortDesc = !this.sortDesc
      } else {
        this.sortBy = fieldKey
        this.sortDesc = false
      }
    },
    mixedLimitSortAttrs(field) {
      if (!this.isMixedLimitSortable(field)) {
        return {}
      }

      return {
        'aria-sort': this.sortBy === field.key
            ? (this.sortDesc ? 'descending' : 'ascending')
            : 'none',
      }
    },
    onMixedLimitRowClicked(item) {
      const sourceRow = item?._sourceRow || item

      if (item._displayRowKind === 'child') {
        return this.onChildRowClicked(sourceRow)
      }
      if (sourceRow?.type === 'group') {
        sourceRow._showDetails = !sourceRow._showDetails
        return
      }
      this.$router.push({path: `/customers/${sourceRow.id}`, append: true})
    },
    onRowClicked(item) {
      if (item.type === 'group') {
        item._showDetails = !item._showDetails
        return;
      }
      this.$router.push({path: `/customers/${item.id}`, append: true})
    },
    onChildRowClicked(item) {
      this.$router.push({path: `/customers/${item.id}`, append: true})
    },
    onSearchInput(value) {
      this.searchInput = value;
      this.queryUpdate({search: value || undefined});
    },
    onClickSyncUpdatedToday() {
      this.syncLoading = true;
      return this.$axios.post('/v1/obligor-limit-groups/mixed/updated-today/sync')
          .then(() => {
            return this.syncUpdatedTodayQueueInProgressAlert();
          })
          .catch(e => this.failedAlert(e))
          .finally(() => {
            this.syncLoading = false;
          })
    },
    syncUpdatedTodayQueueInProgressAlert() {
      return Swal.fire({
        title: `Sync Odoo Contact in Progress`,
        type: "primary",
        confirmButtonClass: "btn btn-success",
        confirmButtonText: this.$t("ok"),
        buttonsStyling: false
      }).then((res) => {
        if (res.isConfirmed) {
          this.$router.go(0)
        }
      });
    },
    refreshTable() {
      if (this.isCustomerTableMode) {
        this.mixedLimitFetchId += 1
        this.busy = false
        this.$nextTick(() => {
          if (this.$refs.table && typeof this.$refs.table.refresh === 'function') {
            this.$refs.table.refresh()
          }
        })
        return
      }

      const fetchId = ++this.mixedLimitFetchId
      this.busy = true
      this.fetchCustomerSummary()
      this.fetchIntegrationSyncStatuses()
      return this.fetchMixedLimitGroups(this.page, fetchId)
          .finally(() => {
            if (fetchId === this.mixedLimitFetchId) {
              this.busy = false
            }
          })
    },
    scrollTableToTop() {
      this.$nextTick(() => {
        const tableRoot = this.$refs.table && this.$refs.table.$el;
        const mixedTable = this.$el && this.$el.querySelector ? this.$el.querySelector('.mixed-limit-table') : null;
        if (!tableRoot && !mixedTable) return;
        const scrollableSection =
            (tableRoot && tableRoot.querySelector('.table-responsive')) ||
            tableRoot ||
            (mixedTable && mixedTable.closest('.table-responsive')) ||
            mixedTable;
        if (scrollableSection) {
          scrollableSection.scrollTop = 0;
        }
      });
    },
    onPageChanged() {
      this.scrollTableToTop();
    },
    childLimits(group) {
      if (!group || !Array.isArray(group.odoo_obligor_limits) || !group.odoo_obligor_limits.length) {
        return []
      }
      return group.odoo_obligor_limits.map((limit) => {
        let customer = limit?.odoo_res_partner?.customer

        return {
          id: customer?.id,
          code: customer?.code,
          name: customer?.name,
          limit_amount: group.limit_amount,
          used_amount: typeof limit.used_amount === 'number' ? limit.used_amount : 0,
          used_amount_ratio: typeof limit.used_amount === 'number' ? limit.used_amount / group.limit_amount : 0,
          available_amount: group.available_amount,
          max_days_past_due_in_90_days: limit.odoo_res_partner?.max_days_past_due_in_90_days,
          type: 'child',
          _denyShow: false,
          _denyEdit: !this.$auth.hasPermissionTo("customers.edit"),
          _denyDelete: !this.$auth.hasPermissionTo("customers.delete"),
        }
      }).filter(({id}) => id)
    },
    formatCurrency(value) {
      if (value === null || typeof value === 'undefined') {
        return '-'
      }
      return this.$numeral(value).format('$0,0.[00]')
    },
    formatPercentage(value) {
      if (value === null || typeof value === 'undefined') {
        return '-'
      }
      return this.$numeral(value).format('0,0.[00]%')
    },
    delete(value) {
      return this.$axios.delete(`/customers/${this.getModelKey(value)}`)
    },
    getJalaFarmIdFromCustomer(customers) {
      const data = Array.isArray(customers) ? [...customers] : [customers]
      let farms = this.lodash.flatten(data.map(({farms}) => farms.filter((farm => farm.use_jala_farm))), 1)
      let uniqFarms = this.lodash.uniqBy(farms, 'jala_farm_id')

      return uniqFarms.map(({jala_farm_id}) => jala_farm_id)
    },
    mapCustomersByJalaFarms(customers, jalaFarms) {
      return customers.map(customer => ({
        ...customer,
        farms: customer.farms.map(farm => ({
          ...farm,
          pro_ponds: jalaFarms.find(({id}) => id === farm.jala_farm_id)?.pro_ponds ?? [],
        }))
      }))
    },
    fetchJalaFarm(options) {
      return this.$axios.get('/jala/farms', options)
    },
    fetchCustomers(page = 1) {
      return this.$axios.get('/v1/customers', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          include: [
            'farms',
            'addresses',
            'creator',
          ].join(','),
          sort: this.sortDesc ? `-${this.sortBy}` : this.sortBy,
          'filter[type]': this.filter?.type,
        }
      }).then((response) => {
        const {data: {data, meta}} = response;
        const customers = data.map((datum) => ({
          ...datum,
          ...this.modelPolicy(),
        }))
        this.models = customers
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);
        this.stats = [
          {
            title: this.lodash.upperFirst(this.$t('customers.count')),
            value: this.$numeral(this.total).format('0,0 a'),
            valueTitle: this.$numeral(this.total).format('0,0'),
            // icon: 'bx bx-user',
            wrapperClass: 'col-md-2',
          },
        ]
        let jalaFarmIds = this.getJalaFarmIdFromCustomer(data)
        if (!jalaFarmIds.length) {
          return customers
        }

        return this.fetchJalaFarm({
          params: {
            keys: jalaFarmIds.join(','),
            with: ['pro_ponds'].join(','),
            per_page: 1000,
          }
        }).then(res => {
          const {data: {data: jalaFarms}} = res
          const jalaFarmsHaveProPond = jalaFarms.filter(({pro_ponds}) => pro_ponds.length)
          const mappedCustomers = this.mapCustomersByJalaFarms(customers, jalaFarmsHaveProPond)
          this.$set(this, 'models', mappedCustomers)

          return mappedCustomers
        })
      }).catch((error) => this.failedAlert(error));
    },
    fetchCustomerSummary() {
      this.customerSummaryLoading = true;
      return this.$axios.get('/v1/customers/summary')
          .then(res => {
            const {data: {data}} = res;
            this.$set(this, 'customerSummary', data)

            return res
          })
          .finally(() => {
            this.customerSummaryLoading = false
          })
    },
    fetchIntegrationSyncStatuses() {
      return this.$axios.get('/v1/integration-syncs-statuses')
          .then(res => {
            const {data: {data}} = res;
            this.$set(this, 'lastSuccessSyncAt', data.overall_last_success_sync_at)

            return res
          })
    },
    itemProvider(ctx) {
      const {
        filter,
        currentPage = 1,
      } = ctx
      this.fetchCustomerSummary()

      if (['farmer', 'partner'].includes(filter.type)) {
        return this.fetchCustomers(currentPage)
      }
      return this.fetchMixedLimitGroups(currentPage).then(({data: {data}}) => {
        return data.map(datum => {
          if (datum.type === 'individual') {
            return {
              ...datum,
              limit_amount: 0,
              used_amount: 0,
              used_amount_ratio: 0,
              available_amount: 0,
              _showDetails: false,
              _denyShow: false,
              _denyEdit: !this.$auth.hasPermissionTo("customers.edit"),
              _denyDelete: true,
            }
          }

          return {
            ...datum,
            _showDetails: false,
            _denyShow: true,
            _denyEdit: !this.$auth.hasPermissionTo("customers.edit"),
            _denyDelete: true,
          }
        })
      })
    },
    fetchMixedLimitGroups(page = 1, fetchId = this.mixedLimitFetchId) {
      return this.$axios.get('/v1/obligor-limit-groups/mixed', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: this.sortDesc ? `-${this.sortBy}` : this.sortBy,
        }
      }).then((response) => {
        const {data: {data, current_page, per_page, from, total}} = response;
        if (fetchId !== this.mixedLimitFetchId || this.isCustomerTableMode) {
          return response
        }
        this.models = data.map((datum) => {
          return datum.type === 'individual' ? {
            ...datum,
            ...this.modelPolicy(),
            _showDetails: false,
          } : {
            ...datum,

            _denyShow: true,
            _denyEdit: !this.$auth.hasPermissionTo("customers.edit"),
            _denyDelete: true,
            _showDetails: false,
          }
        })
        this.page = Number(current_page);
        this.perPage = Number(per_page);
        this.from = Number(from);
        this.total = Number(total);

        this.stats = [
          {
            title: this.lodash.upperFirst(this.$t('customers.count')),
            value: this.$numeral(this.total).format('0,0 a'),
            valueTitle: this.$numeral(this.total).format('0,0'),
            wrapperClass: 'col-md-2',
          },
        ]

        return response;
      });
    },
    modelPolicy() {
      let modelPolicy = {
        _denyShow: false,
        _denyEdit: false,
        _denyDelete: true,
      }
      let userPolicy = {
        _denyEdit: !this.$auth.hasPermissionTo("customers.edit"),
      }
      return {
        ...modelPolicy,
        ...userPolicy,
      }
    },
    showCreateModal() {
      this.$bvModal.show('customer-create-modal')
    },
    showEditModal(event) {
      if (this.activeCustomerType === 'processing' && event.type === 'group') {
        this.$refs.odoo_obligor_limit.edit(event.id)
      } else {
        this.$refs.customer_edit_modal.edit(event.id)
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~@/design/app";
@import "../../../design/custom/components/status-badge";

::v-deep {
  .w-1 {
    width: 1% !important;
  }

  .w-50px {
    width: 50px !important;
  }

  .w-70px {
    width: 70px !important;
  }

  .w-75px {
    width: 75px !important;
  }

  .w-80px {
    width: 80px !important;
  }

  .w-150px {
    width: 150px !important;
  }

  .w-200px {
    width: 200px !important;
  }

  .p-12px {
    padding: 12px !important;
  }

  .card {
    .card-sub-title {
      font: 400 14px/16px Lato, sans-serif;

      &.text-muted {
        color: #6C7589 !important;
      }
    }

    .customer-metric-bold {
      font: 800 36px Lato, sans-serif;
    }
  }


  .child-detail-table {
    margin: 0;
    border-width: 0 !important;
    border-radius: 0 !important;
  }

  .mixed-limit-table {
    margin: 0;
    border-width: 0 !important;
    border-radius: 0 !important;
  }

  .mixed-limit-table thead th,
  .mixed-limit-table thead th:first-child,
  .mixed-limit-table thead > tr > [aria-sort] {
    background-color: $neutral-subdued !important;
  }

  .mixed-limit-table .cursor-pointer {
    cursor: pointer;
  }

  .mixed-limit-table .mixed-limit-child-row td {
    font-size: 12px;
    background: white !important;
  }

  .mixed-limit-table .mixed-limit-child-cell {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }

  .mixed-limit-table .mixed-limit-group-row td {
    background: #f5f6f7;
  }

  .child-detail-table thead th,
  .child-detail-table tbody th {
    background: $neutral-subdued;
    border-color: transparent;
  }

  .child-detail-table tbody tr td,
  .child-detail-table tbody tr td > * {
    font-size: 12px;
    background: white !important;
  }

  .jds-table {
    .table-responsive {
      overflow-x: auto;
    }
  }

  .table-model {
    @extend .jds-table;

    table {
      @extend .table-zebra;
    }
  }

  .table.b-table {
    tbody {
      tr.b-table-details {
        td:first-child {
          padding: 0 !important;
        }
      }
    }
  }

  .page-content {
    background: #EEF3F7 !important;
    font-family: Lato;
    color: #161B4D;
  }

  .dataTables_paginate.paging_simple_numbers {
    margin-top: 0.5rem;
  }

  .dataTables_length select {
    height: 39px;
    // background: #F4F7FA;
    border: 1px solid #dbdce2;
    border-radius: 8px;
    font-weight: 700;
    font-size: 16px;
  }

  .dataTables_filter {
    position: relative;

    input {
      height: 39px;
      padding-left: 34px;
      background: #f4f7fa;
      border: 1px solid #dbdce2;
      border-radius: 8px;
    }

    input::placeholder {
      font-weight: 500;
      font-size: 14px;
      color: #7e889d;
    }

    .prefix-icon {
      position: absolute;
      top: 10px;
      left: 18px;
    }
  }

  .page-item.active {
    button {
      border-radius: 4px !important;
    }
  }

  .mini-stats-wid {
    .media-body {
      p {
        font-weight: 500;
        font-size: 14px;
        color: #6C7589 !important;
      }

      h4 {
        font-weight: 800;
        font-size: 18px;
        color: #161B4D;
      }
    }
  }
}
</style>
